import { Menu, MenuItem } from '@blueprintjs/core';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import { useClearDiagram } from 'src/containers/ProjectDiagram/hooks/useClearDiagram';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { MappingLink } from 'src/containers/ProjectDiagram/types/diagram';
import { addDeletedData } from 'src/containers/ProjectDiagram/utils/addDeletedData';
import {
  DiagramModelCommitLayout,
  commitDiagramModel,
} from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { removeMapping } from 'src/containers/ProjectDiagram/utils/mapping/removeMapping';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { useNavigateMapping } from 'src/utils/hooks/useNavigateMapping';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';

type MappingContextMenuProps = {
  link: MappingLink;
};

export const MappingContextMenu: React.VFC<MappingContextMenuProps> = ({
  link,
}) => {
  const dispatch = useReduxDispatch();
  const diagram = useDiagram();
  const clearDiagram = useClearDiagram();
  const navigateMapping = useNavigateMapping();

  const handleSelectMapping = React.useCallback(() => {
    if (!link) {
      return;
    }
    navigateMapping(link.data.value);
  }, [link, navigateMapping]);

  const handleOpenSettings = React.useCallback(() => {
    if (!link) {
      return;
    }
    dispatch(
      uiSlice.actions.toggledProjectMappingSettingsDrawer({
        isOpen: true,
        mappingId: link.data.value,
      })
    );
  }, [dispatch, link]);

  return (
    <Menu>
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.mapping}
        onClick={handleSelectMapping}
        text={copy.components.projectDiagram.contextMenu.mapping}
      />
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.settings}
        onClick={handleOpenSettings}
        text={copy.components.projectDiagram.contextMenu.settings}
      />
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.delete}
        onClick={() => {
          if (!diagram || !link) {
            return;
          }

          clearDiagram();
          commitDiagramModel(
            diagram,
            (model) => {
              addDeletedData([link.data])(model);
              removeMapping(link.data)(model);
            },
            { layout: DiagramModelCommitLayout.PARTIAL }
          );
        }}
        text={copy.components.projectDiagram.contextMenu.delete}
      />
    </Menu>
  );
};
